// Using import as a side effect does not always apply styles in React in all tooling.
// Instead, use require if you suspect `import` isn't working.
// Or, check the build system for CSS loader support.

// Try requiring the CSS file directly:
import {
  VolumeDownIcon,
  VolumeUpIcon,
} from "../../assets/pixel-icons/volumeDown.js";

import "./Ipod.css";
import { useState, useEffect } from "react";
import { colors } from "../../styles/theme.js";
import { usePlayerRef } from "../../Context/PlayerRefProvider.tsx";
function getUrlParam(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

export const IpodVolume = () => {
  const { playerRef } = usePlayerRef();

  const [volume, setVolume] = useState(null);

  const volumeParam = getUrlParam("volume");

  useEffect(() => {
    if (playerRef.current?.getVolume) {
      setVolume(`${playerRef.current.getVolume()}`);
    }
  }, [playerRef]);

  const handleVolumeChange = (e) => {
    setVolume(e.target.value);
    playerRef.current?.setVolume(e.target.value);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
      <input
        type="range"
        min="0"
        max="100"
        defaultValue={volumeParam || volume}
        onChange={handleVolumeChange}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <VolumeDownIcon
          width={42}
          height={42}
          style={{ color: colors.black }}
        />
        <VolumeUpIcon width={42} height={42} style={{ color: colors.black }} />
      </div>
    </div>
  );
};
